import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import TestBanner from './components/TestBanner';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
// Loaded as plain CSS (via css-loader) rather than through Sass: the minified
// semantic-ui-css contains CSS that Dart Sass rejects but css-loader/PostCSS tolerates.
import 'semantic-ui-css/semantic.min.css';
import './styles/all.scss'

const FallbackRouterApp = () => {
    return (
        <BrowserRouter>
            <>
                <TestBanner />
                <Switch>
                    <Route path="/:page?" component={App} />
                </Switch>
            </>
        </BrowserRouter>
    )
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<FallbackRouterApp />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
